export * from './services/app.service';
export * from './services/http.service';
export * from './services/user.service';
export * from './services/pago/pago.service';
export * from './services/plato/plato.service';
export * from './models/pedido.model';
export * from './models/plato.model';
export * from './services/settings/settings.service';
export * from './services/modal/modal.service';
export * from './directives/img-preload.directive';
export * from './services/router/router.service';
export * from './services/email/email.service';

export { PedidoService } from './services/pedido/pedido.service';